const defiant = window.defiant;

export function performDrugSearch(drugTerm, gSnapshot) {
  const xPress = `//*[contains(d, "${drugTerm}")]`;
  let results = defiant.search(gSnapshot, xPress);
  let exactMatch, exactMatchDrug;

  let matchResults = results.filter((result) => {
    let matchFound = false;
    if (result.d !== undefined) {
      Object.keys(result.d).forEach((key) => {
        if (result.d[key].toLowerCase().includes(drugTerm)) {
          matchFound = true;
        }
        if (result.d[key].toLowerCase() === drugTerm) {
          exactMatch = result;
          exactMatchDrug = key;
        }
      });
    }
    return matchFound;
  });

  let flattedResults = [];
  matchResults.forEach((result) => {
    Object.keys(result.d).forEach((i) => {
      // if (optionCount >= 40) return;
      const currentDrug = result.d[i];
      if (
        currentDrug
          .toLowerCase()
          .split(" ")[0]
          .startsWith(drugTerm.split(" ")[0])
      ) {
        flattedResults.push({
          i: result.i,
          d: currentDrug,
          k: result.k,
          t: result.t,
          s: result.s,
        });
      }
    });
  });

  flattedResults.sort((a, b) => {
    const aIndex = a.d.toLowerCase().indexOf(drugTerm);
    const bIndex = b.d.toLowerCase().indexOf(drugTerm);
    if (aIndex === bIndex) {
      return a.d.localeCompare(b.d);
    }
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });

  // debugger;

  return { flattedResults, exactMatch, exactMatchDrug };
}